export default __webpack_public_path__ + "static/media/tree_1.d5a437fa.png";